import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { PasswordInput } from "@/components/PasswordInput";
import { generatePassword } from "@/lib/format";

export const InviteOrPassword = ({ invite, setInvite, password, setPassword, testPrefix }) => (
  <div className="space-y-2">
    <label className="flex items-center justify-between gap-3 rounded-md border border-slate-200 bg-white px-3 py-2.5 cursor-pointer">
      <span className="flex items-center gap-2 text-sm text-slate-800">
        <Mail className="w-4 h-4 text-sky-700" />Send invitasjon på e-post – brukeren lager eget passord
      </span>
      <Switch checked={invite} onCheckedChange={setInvite} data-testid={`${testPrefix}-invite-switch`} />
    </label>
    {!invite && (
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex-1">
          <PasswordInput placeholder="Passord (min. 8 tegn)" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" testId={`${testPrefix}-password`} />
        </div>
        <Button type="button" variant="outline" className="h-11" onClick={() => setPassword(generatePassword())} data-testid={`${testPrefix}-generate`}>Generer</Button>
      </div>
    )}
  </div>
);

export const inviteToast = (toast, email, sent) => {
  if (sent === true) toast.success(`Invitasjon er sendt til ${email}`);
  else if (sent === false) toast.warning(`Brukeren er opprettet, men e-posten til ${email} kunne ikke sendes. Prøv «Send invitasjon på nytt».`);
  else toast.success(`${email} er lagt til`);
};
